import { PlannedDemandPageThemeSizeConfig } from './types';

const small: PlannedDemandPageThemeSizeConfig = {
  plannedDemandPage: {},
};

export default small;
